'use client';
import React, { useState, useEffect, useCallback } from 'react';

interface Testimonial {
  id: number;
  quote: string;
  author: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    quote: "This place is awesome! You won't pay $8 a cup here, though it's worth it! The coffee taste great! Great customer service. I will return for another cup soon!",
    author: 'Casey H.',
  },
  {
    id: 2,
    quote: 'Great coffee—from the shop and at home too!',
    author: 'Tina R.',
  },
  {
    id: 3,
    quote: "Delicious coffee. We're excited to make going to Bayside Coffee Co part of our vacation tradition",
    author: 'Travis P.',
  },
];

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const goNext = useCallback(() => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(goNext, 4000);
    return () => clearInterval(timer);
  }, [goNext]);

  return (
    <section className="testimonials-section">
      <div className="page-width">
        <div className="section-header">
          <h2 className="section-title">Testimonials</h2>
        </div>
        <div className="quotes-wrapper">
          <div className="quotes-slider">
            {testimonials.map((t, i) => (
              <div
                key={t.id}
                className={`quote-slide ${i === activeIndex ? 'quote-slide--active' : ''}`}
              >
                <blockquote className="quote-block">
                  <span className="quote-icon">
                    <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 41 35" width="41" height="35">
                      <path
                        d="M10.208 17.711h6.124v16.332H0V21.684C0 8.184 5.444.956 16.332 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766zm24.498 0h6.124v16.332H24.498V21.684C24.498 8.184 29.942.956 40.83 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766z"
                        fill="#000"
                        fillRule="evenodd"
                      />
                    </svg>
                  </span>
                  <p className="quote-text">{t.quote}</p>
                  <cite className="quote-author">— {t.author}</cite>
                </blockquote>
              </div>
            ))}
          </div>
          <div className="quote-dots">
            {testimonials.map((_, i) => (
              <button
                key={i}
                className={`quote-dot ${i === activeIndex ? 'quote-dot--active' : ''}`}
                onClick={() => setActiveIndex(i)}
                aria-label={`Go to testimonial ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        .testimonials-section {
          padding: 50px 0;
          font-family: 'Work Sans', sans-serif;
          background: #fff;
        }
        .page-width {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 30px;
        }
        .section-header {
          text-align: center;
          margin-bottom: 30px;
        }
        .section-title {
          font-size: 20px;
          font-weight: 600;
          color: #3d4246;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin: 0;
          font-family: 'Work Sans', sans-serif;
        }
        .quotes-wrapper {
          position: relative;
        }
        .quotes-slider {
          display: flex;
          overflow: hidden;
          position: relative;
          min-height: 180px;
        }
        .quote-slide {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          opacity: 0;
          transition: opacity 0.5s ease;
          pointer-events: none;
        }
        .quote-slide--active {
          opacity: 1;
          position: relative;
          pointer-events: auto;
        }
        .quote-block {
          text-align: center;
          margin: 0;
          padding: 0 20px;
        }
        .quote-icon {
          display: block;
          margin-bottom: 16px;
        }
        .quote-text {
          font-size: 16px;
          color: #3d4246;
          line-height: 1.7;
          margin: 0 0 12px 0;
          font-style: italic;
          font-family: 'Work Sans', sans-serif;
        }
        .quote-author {
          font-size: 15px;
          color: #3d4246;
          font-style: normal;
          font-weight: 500;
          font-family: 'Work Sans', sans-serif;
        }
        .quote-dots {
          display: flex;
          justify-content: center;
          gap: 8px;
          margin-top: 24px;
        }
        .quote-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #dcdcdc;
          border: none;
          cursor: pointer;
          padding: 0;
          transition: background 0.2s;
        }
        .quote-dot--active {
          background: #3d4246;
        }
      `}</style>
    </section>
  );
}
